// DCC plugin runtime config. Every DCC plugin (Blender, 3ds Max, Maya, Unity,
// Unreal, ...) speaks the same protocol, each on its own local port, so a
// single generic client under Services/dccBridge/plugin/ serves them all.

export const PLUGIN_HOST = 'localhost'

// Keyed by the plugin key (see Shared/Utils/dccPluginKeys.js), matching the
// port each DCC plugin binds locally.
export const PLUGIN_PORTS = {
  blender: 49485,
  maya: 49486,
  max: 49487,
  unreal: 49488,
  unity: 49489,
}

export const getPluginWsUrl = (pluginKey) => `ws://${PLUGIN_HOST}:${PLUGIN_PORTS[pluginKey]}`
export const getPluginHealthUrl = (pluginKey) => `http://${PLUGIN_HOST}:${PLUGIN_PORTS[pluginKey]}/health`
